import type { FC } from "react";

import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { Actions, ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";
import { GenericSearchFormCriteria } from "../../../oldComponents/GenericSearchFormCriteria";
import type { PaymentMethodProfile } from "../../../types/entities/paymentMethodProfile";
import { PaymentMethodProfilesTable } from "./PaymentMethodProfilesTable";

export const PaymentMethodProfilesPage: FC<NoneOwnProps> = () => {
    const table = <PaymentMethodProfilesTable />;
    const searchForm = (
        // <SearchForm>
        <GenericSearchFormCriteria />
        // </SearchForm>
    );

    return (
        <PageLayout>
            <PageTitle translationKey="menu.methodsOfPaymentProfiles" />
            <ResourceManager<PaymentMethodProfile>
                useDataGroup
                dataMapperKey="paymentMethodProfilesTableData"
                resource={ResourceName.PAYMENT_METHOD_PROFILES}
                table={table}
                searchForm={searchForm}
                actions={[Actions.ADD, Actions.DELETE, Actions.COPY, Actions.EXPORT]}
            />
        </PageLayout>
    );
};
